import type { AgentExecutionLight } from "@stockline/shared/types/ai/execution"
import type { OfflineResourceConfig } from "../../../types"
import { EXECUTION_TABLE } from "./db"

export const executionConfig: OfflineResourceConfig<AgentExecutionLight> = {
  name: "executions",
  // STK-1324: deferred, non-blocking -- hydrated via the SSE replay handshake
  // (cursor=0 full-table replay) AFTER readiness, not the cold-start waves.
  tier: "background",
  endpoints: {
    full: "/api/v2/executions?fields=light",
    delta: "/api/v2/executions/changes",
    push: "/api/v2/executions/changes",
  },
  tableName: EXECUTION_TABLE,
  primaryKey: "id",
  indexes: {
    agentType: "agentType",
    status: "status",
    createdAt: "createdAt",
  },
  applyChange: (local, patch) => ({ ...local, ...patch }),
}
